import {ChecklistRepository} from '../repository/ChecklistRepository';
import {Checklist, ChecklistPayload} from '../models/checklist.model';

export class UpdateChecklistUseCase {
  constructor (private checklistRepository: ChecklistRepository) {}

  async execute (id: number, payload: ChecklistPayload): Promise<Checklist> {
    return this.checklistRepository.update(id, payload);
  }
}
